import{purry as e}from"./purry-DH9cw9sy.js";function t(...t){return e(n,t)}const n=(e,t)=>e.length>=t;export{t as hasAtLeast};
//# sourceMappingURL=hasAtLeast-F1Oj_xBB.js.map